export default "__VITE_ASSET__Dm$hiQ4G__"